import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';

import {FormTypesData} from '../../../../domains/common.domain';
import {CommonService} from '../../../../services/common.service';
import {AllDropdownKeys} from '../../../jurisdiction.constants';
import {LookupOptionsData} from '../../../jurisdiction.domain';
import {FacilitiesFormService} from '../../facilities-form.service';

@Component({
  selector: 'app-new-facility',
  styleUrls: ['./new-facility.component.scss'],
  templateUrl: './new-facility.component.html',
})

export class NewFacilityComponent implements OnInit {

  @Input() currentFormType: FormTypesData;
  @Input() isReadOnly: boolean = false;
  @Input() newFacilityData: any = null;

  formSubscription: Subscription;
  measuringPointKey: string;
  measuringPointOperators: LookupOptionsData[];
  newFacilityFG: FormGroup;
  selectedMeasuringPointOperator: string;

  constructor(
    private commonService: CommonService,
    private facilitiesFormService: FacilitiesFormService,
  ) {
    this.measuringPointKey = AllDropdownKeys.MeasuringPointOperator;
  }

  ngOnInit(): void {
    this.measuringPointOperators = this.commonService.getDropdownData(this.measuringPointKey);
    this.prepareForm();

    this.facilitiesFormService.registerForComponentFormUpdate.next({
      component: 'newFacility',
      formData: this.newFacilityFG,
    });
    this.facilitiesFormService.registerForActionOnFormSubmit.subscribe(
      (value: boolean) => {
        if (value) {
          this.resetData();
        }
      });
  }

  prepareForm(): void {
    this.selectedMeasuringPointOperator = this.newFacilityData && this.newFacilityData.measuringPointOperator || '';
    this.newFacilityFG = new FormGroup({
      installationId: new FormControl(this.newFacilityData && this.newFacilityData.installationId || ''),
      measuringPointOperator: new FormControl(this.selectedMeasuringPointOperator, [Validators.required]),
      company: new FormControl(this.newFacilityData && this.newFacilityData.company || ''),
    });

    this.formSubscription = this.newFacilityFG.valueChanges.subscribe(() => {
      this.facilitiesFormService.manageComponentFormUpdate({
        component: 'newFacility',
        formData: this.newFacilityFG,
      });
    });
  }

  onOperatorChange(event): void {
    this.selectedMeasuringPointOperator = event.value;
    if (this.selectedMeasuringPointOperator === 'other') {
      this.newFacilityFG.controls.company.setValidators([Validators.required]);
    } else {
      this.newFacilityFG.controls.company.clearValidators();
    }
    this.newFacilityFG.controls.company.updateValueAndValidity();
  }

  private resetData(): void {
    this.formSubscription.unsubscribe();
    this.prepareForm();
  }

  isValid(): boolean {
    return this.newFacilityFG.valid;
  }
}
